<template>
  <div class="box">
    <div class="box-title">
      <img src="../../../assets/app/myApps.png" alt="">
      <font>我的应用</font>
    </div>
    <div class="box-content">
      <div class="box-content-items">
        <div class="box-content-items-item">
          <img src="../../../assets/app/report-01.png" alt="">
          <p>客户发展</p>
        </div>
        <div class="box-content-items-item">
          <img src="../../../assets/app/report-02.png" alt="">
          <p>收入</p>
        </div>
        <div class="box-content-items-item">
          <img src="../../../assets/app/report-03.png" alt="">
          <p>4G流量</p>
        </div>
        <div class="box-content-items-item">
          <img src="../../../assets/app/report-04.png" alt="">
          <p>新业务</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      active: true
    }
  },
  props: [],
  watch: {},
  mounted() {},
  methods: {}
}

</script>
<style lang="less" scoped>
@font-color1: #43484D; //标题
@font-color2: #86939E; //一般文字
@font-color3: #0384DF; //蓝色
@font-color4: #FFF; //白色
@font-color5: #31373D; //黑色
.box {
  font-family: "PingFang-SC-Regular";
  overflow: hidden;
}

.box-title {
  color: @font-color1;
  height: 0.84rem;
  line-height: 0.84rem;
  text-align: center;
  font-size: 0.31rem;
  font-family: 'PingFang-SC-Heavy';
  border-bottom: 0.02rem solid #eee;
  img {
    position: relative;
    width: 0.34rem;
    top: 0.05rem;
    margin-right: 0.1rem;
  }
}
.box-content {
  padding: 0.2rem 0 0.2rem 0;
  .box-content-items:first-child{
    margin-bottom: 0.1rem;
  }
  .box-content-items {
    display: flex;
    .box-content-items-item {
      flex: 1;
      text-align: center;
      img {
        width: 0.66rem;
      }
      p {
        font-size: 0.26rem;
        color: #86939E;
        padding: 0;
        margin: 0;
        margin-top: -0.1rem;
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/app/index/myApps.vue